import React, { Component } from 'react';
import CourseMiddleware from '../../store/middleware/courseMiddleware';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modules from '../Modules/modules';
import ErrorHandler from "../ErrorHandler/errorhandler";
import CourseActions from '../../store/actions/courseActions';
import { connect } from 'react-redux';

var user ;

class CourseHome extends Component {
    constructor() {
        super();
        this.state = {
            moduleLoader: true,
            quizLoader: false,
            quizListPanel: null,
            quizDetailsPanel: null,
            errorPopupOpen: false,
        }
    }

    componentWillReceiveProps(nextprops) {
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(!userProps){
            this.props.history.push('/');
        }

        if (nextprops.quizDetails && nextprops.quizDetails.quiz) {
            this.setState({
                quizLoader: nextprops.loader
            })
        }
        
        if (nextprops.isErrorInModules) {
            this.setState({
                errorPopupOpen: true,
                moduleLoader : false
            })
        }

        if (nextprops.moduleDetails && nextprops.moduleDetails.modules && nextprops.moduleDetails.modules.length) {
            this.setState({
                moduleLoader: nextprops.loader
            })
        }
    }
    
    componentDidMount() {
        this.props.getmodule({ 
            userId: user._id, 
            pc_access_token: user.pc_access_token, 
            courseId: this.props.location.state.course._id
        })
        sessionStorage.setItem("courseName", window.location.pathname.split('/')[2])
        sessionStorage.removeItem('proctoringKey')
    }

    getQuizInfo(data) {
        this.props.getquiz({ 
            quizId: data.quiz, 
            userId: user._id, 
            courseId: this.props.location.state.course._id, 
            pc_access_token: user.pc_access_token,
            classId: this.props.location.state.course.classes[this.props.location.state.index]._id
        })
        this.setState({
            quizLoader: true
        })
    }

    showQuizList = panel => (event, quizListPanel) => {
        this.setState({
            quizListPanel: quizListPanel ? panel : false,
            quizDetailsPanel:null
        });
    };

    showQuizDetails = (panel,data) => (event, quizDetailsPanel) => {
        this.setState({
            quizDetailsPanel: quizDetailsPanel ? panel : false,
        });
        this.getQuizInfo(data);
    };

    errorPopupClose = () => {
        this.props.getmodule({ 
            userId: user._id, 
            pc_access_token: user.pc_access_token, 
            courseId: this.props.location.state.course._id
        })
        this.props.clearmodule()
        this.setState({
            moduleLoader: true,
            errorPopupOpen: false
        })
    }

    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        return (
            <div>
                <div style={{ top: "20%", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute", marginBottom : "10%" }}>
                    <span style={{ fontWeight: "bold", fontSize: "large" }}>Welcome to {this.props.location.state.course.name}</span>
                    <span style={{ fontWeight: "bold", fontSize: "large", marginTop: "1%", marginBottom: "1%" }}>Class Name  : {this.props.location.state.classDetails && this.props.location.state.classDetails.title || this.props.location.state.course.classes[this.props.location.state.index].title}</span>
                    {this.state.moduleLoader ?
                        <div><CircularProgress size={50} thickness={3} style={{color : "#13a89e"}} /></div> :
                        <div style={{ width: "75%" }}>
                        {!this.state.errorPopupOpen ?
                        <div>
                            {this.props.moduleDetails && this.props.moduleDetails.modules && this.props.moduleDetails.modules.length && this.props.moduleDetails.modules.map((data, index) => {
                                return <Modules key={index}
                                    quizDetails={this.props.quizDetails}
                                    index={index}
                                    state={this.state}
                                    // reset={()=>this.setState({quizDetailsPanel:null})}
                                    classDetails={this.props.location.state.classDetails || this.props.location.state.course.classes[this.props.location.state.index]}
                                    userDetails={user}
                                    modulesData={data}
                                    quizList={this.showQuizList}
                                    quizData={this.showQuizDetails}
                                />
                            })}
                        </div> : 
                            <ErrorHandler
                                errorPopupOpen={this.state.errorPopupOpen}
                                errorPopupClose={this.errorPopupClose.bind(this)}
                            />
                        }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        moduleDetails: state.courseReducer.modules,
        loader: state.courseReducer.isLoading,
        quizDetails: state.courseReducer.quizInfo,
        isErrorInModules: state.courseReducer.isErrorInModules,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getmodule: (data) => dispatch(CourseMiddleware.modulesMiddleware(data)),
        getquiz: (data) => dispatch(CourseMiddleware.quizInfoMiddleware(data)),
        clearmodule: () => { dispatch(CourseActions.Modules()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CourseHome)


// WEBPACK FOOTER //
// ./src/container/CourseHome/coursehome.js